// API Configuration
// This file centralizes API base URL configuration with proper fallbacks

const getApiBase = () => {
    // Get the environment variable
    let apiBase = process.env.REACT_APP_API_BASE;

    // Remove any leading/trailing whitespace
    if (apiBase) {
        apiBase = apiBase.trim();
    }

    // Fallback logic based on environment
    if (!apiBase || apiBase === '') {
        // Check if we're in production (Vercel)
        if (window.location.hostname.includes('vercel.app')) {
            apiBase = 'https://securechat-system.onrender.com';
        } else {
            // Local development
            apiBase = 'http://localhost:3001';
        }
    }

    // Validate URL format
    if (!apiBase.startsWith('http://') && !apiBase.startsWith('https://')) {
        console.error('Invalid API_BASE URL:', apiBase);
        apiBase = 'http://localhost:3001';
    }

    return apiBase;
};

export const API_BASE = getApiBase();

// Log for debugging (remove in production)
console.log('🔧 API Configuration:', {
    raw: process.env.REACT_APP_API_BASE,
    final: API_BASE,
    hostname: window.location.hostname
});
